import React, {Component} from "react";
import { inject, observer } from "mobx-react";
import DataWrapper from '../../principal/containers/DataWrapper';
import {Button, ButtonGroup, Col, Form, FormGroup, Input, Label, Row} from "reactstrap";
import Select from "react-select";
import DelegacaoTarefasStore from "../stores/DelegacaoTarefasStore";
import DatePicker from "react-datepicker";
import {Validacao} from "../../comum/components/Validacao";
import moment from "moment";
import {LoadingBlockFields} from "../../comum/components/LoadingBlockFields";

@inject("store")
@DataWrapper
@observer
export class DelegacaoTarefas extends Component {
    constructor(props) {
        super(props);
        this.appStore                   = this.props.store.appStore;
        this.validacaoStore             = this.props.store.validacaoStore;
        this.tituloPaginaStore          = this.props.store.tituloPaginaStore;
        this.formStore                  = this.props.store.formStore;
        this.modalStore                = this.props.store.modalStore;
        this.loginStore                = this.props.store.loginStore;
        /* Selecionar Controller */
        this.controller                 = new DelegacaoTarefasStore(this.formStore, this.validacaoStore);
    }

    componentWillMount() {
        this.formStore.setSubmitted(false);
        this.formStore.setSubmitMensagemErro("");
    }

    componentDidMount() {
        this.tituloPaginaStore.setTitulo("Delegação de tarefas")

        this.controller.carregarDados(this.loginStore);
    }

    renderAlerta(){

        if(this.controller.modoEdicao &&
            this.controller.isAtiva === false
            && this.controller.delegacao.codigoRegra != undefined){

            return (
                <Row>
                    <Col xs={12}>
                        <div className="alert-item">
                            Delegações Automáticas Inativas serão Apagadas.
                        </div>
                    </Col>
                </Row>
            );
        }

        return null;
    }

    render() {

        return (
            <div>
                <div className="form-wrapper">
                    <div className="content-panel panel-mini">
                        <div className="panel-form">
                            <LoadingBlockFields carregando={this.controller.carregando}>
                            <Row>
                                <Col xs={12} md={12} lg={12}>
                                    <div className="form-buttons">
                                        <ButtonGroup size="sm">
                                            {
                                                this.controller.modoEdicao ? <Button
                                                    onClick={() => this.controller.reverter()} disabled={this.formStore.solicitando}>Reverter</Button> : null
                                            }
                                            {
                                                this.controller.modoEdicao ?
                                                    <Button color="primary" onClick={() => this.controller.salvar()} disabled={this.formStore.solicitando}>Salvar</Button> : null
                                            }
                                            {
                                                !this.controller.modoEdicao ?
                                                    <Button color="primary" onClick={() => this.controller.editar()} disabled={this.formStore.solicitando}>Editar</Button> : null
                                            }
                                        </ButtonGroup>
                                    </div>
                                </Col>
                            </Row>
                            <div className="panel-form">
                                <Row>
                                    <Col xs={12}>
                                        <FormGroup>
                                            <span >Utilize uma faixa de datas para não ser incluído na atribuição automática de tarefas.</span>
                                        </FormGroup>
                                    </Col>
                                </Row>
                                {
                                    this.renderAlerta()
                                }
                                {this.controller.exibeBotaoAtivar &&
                                <Row>
                                    <Col xs={12}>
                                        <FormGroup check>
                                            <Label check>
                                                <Input type="checkbox" checked={this.controller.delegacao.ativa} onChange={() => this.controller.toggleAtiva()} disabled={!this.controller.modoEdicao} />{' '} Ativar delegação
                                            </Label>
                                        </FormGroup>
                                    </Col>
                                </Row>
                                }
                                <Row>
                                    <Col xs={12}>
                                        <FormGroup>
                                            <Label for="dataInicio">Data inicial</Label>
                                            <DatePicker
                                                ref="dataInicio"
                                                onClickOutside={()=>{this.refs.dataInicio.cancelFocusInput(); this.refs.dataInicio.setOpen(false);}}
                                                locale={"pt_BR"}
                                                className="form-control"
                                                dateFormat="DD/MM/YYYY"
                                                selectsStart
                                                selected={this.controller.momentDataInicio}
                                                minDate={moment()}
                                                startDate={this.controller.momentDataInicio}
                                                endDate={this.controller.momentDataTermino}
                                                onChange={(value) => this.controller.setMomentDataInicio(value)}
                                                onBlur={(e) => this.controller.setDataInicioCheck(e.target.value)}
                                                disabled={!this.controller.modoEdicao || !this.controller.delegacao.ativa}
                                            />
                                            {this.controller.delegacao.ativa && <Validacao id="dataInicioDelegacao" valor={this.controller.dataInicioValidacao}
                                                       tipo={["isDate"]}/>}
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col xs={12}>
                                        <FormGroup>
                                            <Label for="dataTermino">Data de término</Label>
                                            <DatePicker
                                                ref="dataFim"
                                                onClickOutside={()=>{this.refs.dataFim.cancelFocusInput(); this.refs.dataFim.setOpen(false);}}
                                                locale={"pt_BR"}
                                                className="form-control"
                                                dateFormat="DD/MM/YYYY"
                                                selectsEnd
                                                minDate={moment()}
                                                selected={this.controller.momentDataTermino}
                                                startDate={this.controller.momentDataInicio}
                                                endDate={this.controller.momentDataTermino}
                                                onChange={(value) => this.controller.setMomentDataTermino(value)}
                                                onBlur={(e) => this.controller.setDataTerminoCheck(e.target.value)}
                                                disabled={!this.controller.modoEdicao || !this.controller.delegacao.ativa}
                                            />
                                            {this.controller.delegacao.ativa && <Validacao id="dataTerminoDelegacao" valor={this.controller.dataTerminoValidacao}
                                                       tipo={["isDate"]}/>}
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col xs={12}>
                                        <FormGroup>
                                            <Label for="delegar">Delegar a:</Label>
                                            <Select simpleValue cacheAsyncResults={false} value={this.controller.delegacao.usuarioDelegado}
                                                    onChange={(value) => this.controller.setUsuarioDelegado(value)}
                                                    autoload={false}
                                                    searchPromptText="Informe nome para pesquisar" noResultsText="Nenhum resultado encontrado" placeholder="Selecione..."
                                                    asyncOptions={(input, callback) => this.controller.filtrarUsuarios(input, callback)}
                                                    disabled={!this.controller.modoEdicao || !this.controller.delegacao.ativa} />
                                            {this.controller.modoEdicao && this.controller.delegacao.ativa && <Validacao id="usuarioDelegado" valor={this.controller.delegacao.usuarioDelegado}
                                                       tipo={["isRequired"]}/>}
                                        </FormGroup>
                                    </Col>
                                </Row>
                            </div>
                            </LoadingBlockFields>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

